import {Component, Input} from '@angular/core';

@Component({
  selector: 'timecard-details-table',
  templateUrl: './timecard-details-table.component.html',
  styleUrls: ['./timecard-details-table.component.scss']
})
export class TimecardDetailsTableComponent {

  @Input() timecard: TimecardDetails;
  @Input() timecardDays: TimecardDay[] = [];

  // TODO convert this to pipe
  timeToDate(time: string): Date {
    if (!time) {
      return null;
    }

    let parts = time.split(':');
    return new Date(0, 0, 0, +parts[0], +parts[1], +parts[2]);
  }

  processLunchHours(lunch: string): number {
    if (!lunch) {
      return 0;
    }

    let hours: number;
    let minutes: number;

    let parts = lunch.split(':');
    hours = +parts[0];
    minutes = +parts[1] / 60;
    return hours + minutes;
  }
}
